import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { AppSettings } from '../helpers';
import { SupportRequestCreateModel } from '../models/supportRequest';

@Injectable()
export class SupportRequestService {
    constructor(private http: HttpClient,
        private appSettings: AppSettings) { }

    createRequest(model: SupportRequestCreateModel) {
        return this.http.post(this.appSettings.ApiBaseUrl + '/api/support/create', model);
    }
}



// WEBPACK FOOTER //
// ./src/services/support.request.service.ts